package app.svg

import dev.fritz2.core.RenderContext

fun RenderContext.stage(className: String) {
    svg(className) {
        attr("xmlns", "http://www.w3.org/2000/svg")
        attr("fill", "none")
        attr("viewBox", "0 0 24 24")
        attr("stroke-width", "1.5")
        attr("stroke", "currentColor")
        path {
            attr("stroke-linecap", "round")
            attr("stroke-linejoin", "round")
            attr(
                "d",
                "M6.429 9.75 2.25 12l4.179 2.25m0-4.5 5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L21.75 12l-4.179 2.25m0 0 4.179 2.25L12 21.75 2.25 16.5l4.179-2.25m11.142 0-5.571 3-5.571-3"
            )
        }
    }
}
